import createIcon from '../../createIcon';

/**
 * @component @name Timer10Select
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgOFYxNkgxMFY4SDEzWk0xMyA1SDEwQzguMzQgNSA3IDYuMzQgNyA4VjE2QzcgMTcuNjYgOC4zNCAxOSAxMCAxOUgxM0MxNC42NiAxOSAxNiAxNy42NiAxNiAxNlY4QzE2IDYuMzQgMTQuNjYgNSAxMyA1Wk0xIDhIM1YxOUg2VjVIMVY4Wk0xOC41IDExQzE3LjY3IDExIDE3IDExLjY4IDE3IDEyLjVWMTQuNUMxNyAxNS4zMiAxNy42NyAxNiAxOC41IDE2SDIxVjE3SDE3VjE5SDIxLjVDMjIuMzMgMTkgMjMgMTguMzMgMjMgMTcuNVYxNS41QzIzIDE0LjY3IDIyLjMzIDE0IDIxLjUgMTRIMTlWMTNIMjNWMTFIMTguNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Timer10Select = createIcon('Timer10Select', [
  [
    'path',
    {
      d: 'M13 8V16H10V8H13ZM13 5H10C8.34 5 7 6.34 7 8V16C7 17.66 8.34 19 10 19H13C14.66 19 16 17.66 16 16V8C16 6.34 14.66 5 13 5ZM1 8H3V19H6V5H1V8ZM18.5 11C17.67 11 17 11.68 17 12.5V14.5C17 15.32 17.67 16 18.5 16H21V17H17V19H21.5C22.33 19 23 18.33 23 17.5V15.5C23 14.67 22.33 14 21.5 14H19V13H23V11H18.5Z',
      key: '1ll88o',
    },
  ],
]);

export default Timer10Select;
